module.exports = __webpack_public_path__ + "media/src/images/icon/case-c3ea36309a5bc1cdccafa7468f584c8d.png";